module.exports = __webpack_public_path__ + "static/media/berlinoexplorer.da4c589e.png";